var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14311 11.2859H7.85742V1H3.85737L1.00018 6.71437V11.2859H2.71449",
    stroke: "#0990DC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2857 11.2858H17V7.85718H7.85701V11.2858H11.8571",
    stroke: "#0990DC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42827 13.0002C3.48148 13.0002 2.71396 12.2326 2.71396 11.2858C2.71396 10.3391 3.48148 9.57153 4.42827 9.57153C5.37506 9.57153 6.14258 10.3391 6.14258 11.2858C6.14258 12.2326 5.37506 13.0002 4.42827 13.0002Z",
    stroke: "#0990DC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5718 13.0002C12.625 13.0002 11.8575 12.2326 11.8575 11.2858C11.8575 10.3391 12.625 9.57153 13.5718 9.57153C14.5186 9.57153 15.2861 10.3391 15.2861 11.2858C15.2861 12.2326 14.5186 13.0002 13.5718 13.0002Z",
    stroke: "#0990DC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14258 1V5.57149H1.57108",
    stroke: "#0990DC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.7c9a4939bcf950deb4cbf9e84c71c08f.svg";
export { ForwardRef as ReactComponent };